import { Paper, Typography, Box } from '@mui/material';
import { ReactNode } from 'react';

type MetricTileProps = {
    title: string;
    value: string | number;
    icon: ReactNode;
};

const MetricTile = ({ title, value, icon }: MetricTileProps) => {
    return (
        <Paper
            elevation={3}
            sx={{
                padding: 2,
                borderRadius: 2,
                minHeight: 110,
                backgroundColor: '#f9fafb',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                transition: 'transform 0.2s ease-in-out',
                '&:hover': {
                    transform: 'scale(1.02)',
                    boxShadow: 5,
                },
            }}
        >
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                <Typography variant="subtitle2" fontWeight={600} color="#003865">
                    {title}
                </Typography>
                <Box color="#00AEEF">{icon}</Box>
            </Box>
            <Typography variant="h5" fontWeight={700} color="text.primary">
                {value}
            </Typography>
        </Paper>
    );
};

export default MetricTile;
